import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_ADMIN_REQUEST,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_FAILURE,
  UPDATE_ADMIN_REQUEST,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAILURE,
  DELETE_ADMIN_REQUEST,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAILURE,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
} from "../constants/adminConstant.js";

export const addAdminAction = (adminDetails) => async (dispatch) => {
  try {
    dispatch({ type: ADD_ADMIN_REQUEST });
    // const config = {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //   },
    // };
    const { data } = await axios.post(ApiUrl.adminSignup, adminDetails);
    console.log("adminDetails:", adminDetails);

    // for (const [key, value] of adminDetails.entries()) {
    //   console.log(key, value);
    // }
    if (data.success) {
      dispatch({
        type: ADD_ADMIN_SUCCESS,
        payload: data,
      });
      return true;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: ADD_ADMIN_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: ADD_ADMIN_FAILURE,
        payload: error.response.data,
      });
    }
    return false;
  }
};

export const updateAdminAction =
  (adminId, adminDetails) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_ADMIN_REQUEST });

      const URL = `${ApiUrl.updateAdmin}?adminId=${adminId}`;

      const { data } = await axios.post(URL, adminDetails);
      console.log("adminDetails:", data);
      if (data.success) {
        dispatch({
          type: UPDATE_ADMIN_SUCCESS,
          payload: data,
        });
        return data;
      }
    } catch (error) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.status === 500) {
        dispatch({
          type: UPDATE_ADMIN_FAILURE,
          payload: "Internal Server Error",
        });
      } else {
        dispatch({
          type: UPDATE_ADMIN_FAILURE,
          payload: error.response.data,
        });
      }
    }
  };

export const deleteAdminAction = (_id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ADMIN_REQUEST });
    const URL = `${ApiUrl.deleteAdmin}?adminId=${_id}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_ADMIN_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_ADMIN_FAILURE,
      payload: error.response.data,
    });
  }
};

export const getAdminProfileActionFn = (adminId) => async (dispatch) => {
  console.log("adminId:", adminId);
  try {
    dispatch({ type: GET_PROFILE_REQUEST });
    const URL = `${ApiUrl.getAdminById}?adminId=${adminId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_PROFILE_SUCCESS,
        payload: data.response,
      });
      return data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_PROFILE_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_PROFILE_FAILURE,
        payload: error.response.data,
      });
    }
  }
};
